export default function Title() {
    return (
        <div className="bg-background">

            <div className="pt-10">
                <div className="mx-auto px-2 sm:px-4 lg:px-8">
                    <h2 className="text-6xl not-italic font-bold text-white font-title leading-10">Marketplace</h2>
                    <p className="mt-6 text-lg leading-8 text-white">
                        Secure Your Seats: Purchase Tickets listed by your fellow enthusiasts
                    </p>
                </div>
            </div>
        </div>



    )
}